import { render } from "./Privacy_en.vue?vue&type=template&id=59f16cfa&scoped=true&ts=true"
import script from "./Privacy_en.vue?vue&type=script&lang=ts"
export * from "./Privacy_en.vue?vue&type=script&lang=ts"

import "./Privacy_en.vue?vue&type=style&index=0&id=59f16cfa&scoped=true&lang=scss"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f16cfa"]])

export default __exports__